"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.init = init;
exports.radioCheckboxListener = radioCheckboxListener;
exports.addToCartListener = addToCartListener;

var _miniCart = require("./mini-cart.js");

var miniCart = _interopRequireWildcard(_miniCart);

var _themeCart = require("@shopify/theme-cart");

var cart = _interopRequireWildcard(_themeCart);

var _themeProductForm = require("@shopify/theme-product-form");

var _themeProduct = require("@shopify/theme-product");

var _themeCurrency = require("@shopify/theme-currency");

var _micromodal = require("micromodal");

var _micromodal2 = _interopRequireDefault(_micromodal);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _player = require("@vimeo/player");

var _player2 = _interopRequireDefault(_player);

require("slick-carousel");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = {
  hide: "hidden"
}; // Main script for all PDP templates


var selectors = {
  submitButton: "[data-submit-button]",
  notifyButton: "[data-notify-button]",
  comparePrice: "[data-compare-price]",
  comparePriceText: "[data-compare-text]",
  priceWrapper: "[data-price-wrapper]",
  productForm: "[data-product-form]",
  mainProductForm: "[data-main-product-form]",
  productPrice: "[data-product-price]",
  addToCartButton: "[data-add-to-cart]",
  mainProduct: "[data-product]",
  additionalProducts: "[data-additional-product]",
  bundleProducts: "[data-bundle-product]",
  quantity: "[data-product-quantity]",
  imageSlider: "[data-product-image-slider]",
  imageSliderNav: "[data-product-image-slider-nav]",
  onlyDefaultVariant: "[data-only-default-variant]",
  swatch: "[data-swatch]",
  property: "[data-property]",
  sliderVideoPlay: '[data-slider-video-play]',
  sliderVideo: '[data-slider-video]',
  sliderImage: '[data-slider-image]',
  testimonials: '[data-testimonials]',
  stickyForm: "[data-sticky-form]",
  stickyAdd: "[data-sticky-add]",
  showStickyOptions: "[data-show-options]",
  stickySwatch: "[data-sticky-swatch]",
  appsSlider: "[data-apps-slider]"
};

var productForm = void 0;

function init(type) {
  var _this = this;

  // Initialize product form if multiple variants to handle updates for option selections
  if (!document.querySelector(selectors.onlyDefaultVariant)) {
    (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var productFormElement, productFormSticky;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              productFormElement = document.querySelector(selectors.mainProductForm);
              productFormSticky = document.querySelector(selectors.stickyForm);
              _context.next = 4;
              return getProductJson(productFormElement.dataset.productHandle);

            case 4:
              _this.product = _context.sent;

              productForm = new _themeProductForm.ProductForm(productFormElement, _this.product, { onOptionChange: onFormOptionChange.bind(productFormElement) });
              if (productFormSticky) {
                _this.productFormSticky = new _themeProductForm.ProductForm(productFormSticky, _this.product, { onOptionChange: onFormOptionChange.bind(productFormSticky) });
              }

              updateSlideImage.bind(_this)();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }

  // Basic PDP
  productImageSlider.bind(this)();
  addToCartListener.bind(this)();
  if (document.querySelector(selectors.stickyAdd)) {
    stickyAddToCart();
  }
  optionEventListener.bind(this)();
  loadNotifyModal();

  // Master PDP features
  radioCheckboxListener();
  slider();
  info();
  testimonials();
  upgradeData();
  apps();
}

function getProductJson(handle) {
  return fetch("/products/" + handle + ".js").then(function (response) {
    return response.json();
  });
}

function onFormOptionChange(event) {
  var variant = event.dataset.variant;

  // Update prices, buttons, current image, and url on option change
  renderPrice.bind(this, variant)();
  renderComparePrice.bind(this, variant)();
  renderSubmitButton.bind(this, variant)();
  updateVariantId.bind(this, variant)();
  updateSlideImage.bind(this, variant)();
  updateBrowserHistory.bind(this, variant)();
}

// Show main submit button or sold out (notify) button on option change
function renderSubmitButton(variant) {
  var submitButton = this.querySelector(selectors.submitButton);
  var notifyButton = this.querySelector(selectors.notifyButton);
  var addCart = this.querySelector("[data-add-cart]");

  if (!variant) {
    addCart.classList.add(classes.hide);
  } else if (!variant.available) {
    addCart.classList.remove(classes.hide);
    submitButton.classList.add(classes.hide);
    notifyButton.classList.remove(classes.hide);
  } else {
    addCart.classList.remove(classes.hide);
    submitButton.classList.remove(classes.hide);
    notifyButton.classList.add(classes.hide);
  }
}

function renderPrice(variant) {
  var priceElement = this.querySelector(selectors.productPrice);
  var priceWrapperElement = this.querySelector(selectors.priceWrapper);

  priceWrapperElement.classList.toggle(classes.hide, !variant);

  if (variant) {
    priceElement.innerHTML = (0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat);
  }
}

function renderComparePrice(variant) {
  if (!variant) {
    return;
  }

  var comparePriceElement = this.querySelector(selectors.comparePrice);
  var compareTextElement = this.querySelector(selectors.comparePriceText);

  if (!comparePriceElement || !compareTextElement) {
    return;
  }

  if (variant.compare_at_price > variant.price) {
    comparePriceElement.innerText = (0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat);
    compareTextElement.classList.remove(classes.hide);
    comparePriceElement.classList.remove(classes.hide);
  } else {
    comparePriceElement.innerText = "";
    compareTextElement.classList.add(classes.hide);
    comparePriceElement.classList.add(classes.hide);
  }
}

function updateBrowserHistory(variant) {
  var enableHistoryState = productForm.element.dataset.enableHistoryState;

  if (!variant || enableHistoryState !== "true") {
    return;
  }

  var url = (0, _themeProductForm.getUrlWithVariant)(window.location.href, variant.id);
  window.history.replaceState({
    path: url
  }, "", url);
}

function updateVariantId(variant) {
  var productId = this.querySelector(selectors.mainProduct);
  if (variant) {
    productId.value = variant.id;
  }
}

function optionEventListener() {
  document.querySelectorAll(selectors.swatch).forEach(function (swatch) {
    swatch.addEventListener("click", function (evt) {
      var value = swatch.getAttribute("data-option-value");
      var selected = swatch.closest("[data-options]").querySelector("[data-option-selected]");
      if (selected) {
        selected.innerHTML = value;
      }
    });
  });
}

// Update slide image on load based on url and option change 
function updateSlideImage(variant) {
  function update(variant) {
    if (variant.featured_image) {
      var variantImageId = variant.featured_image.id;
      var imageId = document.querySelector("[data-image-id='" + variantImageId + "']");
      var index = parseInt(imageId.dataset.index);
      setTimeout(function () {
        (0, _jquery2.default)(selectors.imageSlider).slick("slickGoTo", index);
        (0, _jquery2.default)(selectors.imageSlider).slick("slickGoTo", index);
      }, 200);
    }
  }
  if (variant) {
    update(variant);
  } else {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (variantId) {
      var _variant = (0, _themeProduct.getVariantFromId)(this.product, parseInt(variantId));
      update(_variant);
    }
  }
}

// Make checkboxes act as radio buttons and allow deselect
function radioCheckboxListener() {
  document.querySelectorAll("[data-radio-checkbox] input").forEach(function (trigger) {
    trigger.addEventListener("change", function () {
      trigger.closest("[data-radio-checkbox]").querySelectorAll("input").forEach(function (item) {
        if (item != trigger) {
          item.checked = false;
        }
      });
    });
  });
}

function loadNotifyModal() {
  if (document.querySelector('[data-load-modal]')) {
    var id = document.querySelector('[data-load-modal]').getAttribute('id');
    _micromodal2.default.show(id);
  }
}

// Main product images slider
function productImageSlider() {
  (0, _jquery2.default)(selectors.imageSlider).slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    fade: true,
    cssEase: "linear",
    asNavFor: selectors.imageSliderNav,
    draggable: true,
    prevArrow: (0, _jquery2.default)(".prev"),
    nextArrow: (0, _jquery2.default)(".next")
  });

  (0, _jquery2.default)(selectors.imageSliderNav).slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    dots: false,
    arrows: false,
    vertical: true,
    asNavFor: selectors.imageSlider,
    draggable: false,
    infinite: false
  });
}

/*
  ** Add to mini cart **

  Usage: To add to mini cart on submit, add "data-product-form" to form, "data-product" to id, and "data-product-quantity" to quantity fields

  Supports adding multiple products to cart for upsells and bundling
*/

function addToCartListener() {
  document.querySelectorAll(selectors.productForm).forEach(function (form) {
    form.addEventListener("submit", function (evt) {
      evt.preventDefault();
      var products = [];
      var timeStamp = Date.now();

      // Main Product: get id, quantity, and upsell properties, then push to products array
      if (form.querySelector(selectors.mainProduct)) {
        var productId = parseInt(form.querySelector(selectors.mainProduct).value);
        var quantity = parseInt(form.querySelector(selectors.quantity).value);
        var properties = {};
        form.querySelectorAll(selectors.property).forEach(function (property) {
          if (property.checked) {
            properties[property.getAttribute("data-property")] = property.getAttribute("data-property-value");
          }
        });
        // Assign id to group upsells if added
        if (Object.keys(properties).length > 0) {
          properties["_attributes_id"] = timeStamp;
        }
        // Identify main product
        properties["_main"] = "main-product";
        products.push({ id: productId, quantity: quantity, properties: properties });
      }

      // Additional Product Upsells
      form.querySelectorAll(selectors.additionalProducts).forEach(function (item) {
        if (item.checked) {
          var _productId = parseInt(item.value);
          // For upsells, will only add 1 to cart
          var _quantity = 1;
          var upsellProperties = {};
          if (item.getAttribute("data-group") == "true") {
            upsellProperties["_attributes_id"] = timeStamp;
          }
          products.push({ id: _productId, quantity: _quantity, properties: upsellProperties });
        }
      });

      // Product Bundling
      form.querySelectorAll(selectors.bundleProducts).forEach(function (item) {
        var productId = parseInt(item.value);
        // For bundling, will only add 1 to cart
        var quantity = 1;
        var bundleProperties = {};
        bundleProperties["_bundle_id"] = timeStamp;
        products.push({ id: productId, quantity: quantity, properties: bundleProperties });
      });

      // Loop through products and add to cart awaiting each promise, then render mini cart with new state
      (function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
          var i;
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  i = 0;

                case 1:
                  if (!(i < products.length)) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.next = 4;
                  return cart.addItem(products[i].id, {
                    quantity: products[i].quantity,
                    properties: products[i].properties
                  });

                case 4:
                  i++;
                  _context2.next = 1;
                  break;

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function loop() {
          return _ref2.apply(this, arguments);
        }

        return loop;
      })()().then(function () {
        cart.getState().then(function (state) {
          miniCart.renderMiniCart(state, false, true);
        });
        document.querySelector("[data-error]").classList.add("hidden");
        document.querySelector("[data-add-cart]").classList.remove("add-error");
      }).catch(function () {
        document.querySelector("[data-error]").classList.remove("hidden");
        document.querySelector("[data-add-cart]").classList.add("add-error");
      });
    });
  });
}

function stickyAddToCart() {
  stickyOptionEventListener();
  showOptionsListener();
  stickyAddShow();
}

function stickyOptionEventListener() {
  document.querySelectorAll(selectors.stickySwatch).forEach(function (swatch) {
    swatch.addEventListener("click", function (evt) {
      var value = swatch.getAttribute("data-option-value");
      var selected = swatch.closest("[data-options]").querySelector("[data-option-selected]");
      if (selected) {
        selected.innerHTML = value;
      }
      document.querySelectorAll('[data-sticky-option]').forEach(function (item) {
        item.classList.add("hidden");
        var attribute = item.getAttribute("data-option-value");
        if (attribute.includes(value)) {
          item.classList.remove("hidden");
        }
      });
    });
  });
}

function showOptionsListener() {
  if (document.querySelector(selectors.showStickyOptions)) {
    document.querySelector(selectors.showStickyOptions).addEventListener("click", function () {
      document.querySelector("[data-options]").classList.toggle("hidden");
    });
  }
}

function stickyAddShow() {
  (0, _jquery2.default)(window).scroll(function () {
    var hT = (0, _jquery2.default)('#product').offset().top,
        hH = (0, _jquery2.default)('#product').outerHeight(),
        wH = (0, _jquery2.default)(window).height(),
        wS = (0, _jquery2.default)(this).scrollTop();
    if (wS > hT + hH - wH + 900) {
      (0, _jquery2.default)(".kpHero__stickyContainer").parent().addClass('show-sticky');
    }
    if (wS < hT + hH - wH + 300) {
      (0, _jquery2.default)(".kpHero__stickyContainer").parent().removeClass('show-sticky');
    }
  });
}

function slider() {
  if ((0, _jquery2.default)(".kpSlider__slider")) {
    (0, _jquery2.default)(".kpSlider__slider").slick({
      dots: true,
      arrows: false,
      lazyLoad: "progressive",
      slidesToShow: 1,
      centerMode: true,
      focusOnSelect: true,
      variableWidth: true,
      centerPadding: "0"
    }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      var current = (0, _jquery2.default)(slick.$slides[currentSlide]);
      var video = current[0].querySelector(selectors.sliderVideo);
      if (video) {
        var player = new _player2.default(video);
        player.getCurrentTime().then(function (seconds) {
          if (seconds > 0) {
            player.pause();
          }
        });
      }
    });
  }

  document.querySelectorAll(selectors.sliderVideoPlay).forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      trigger.parentElement.classList.add(classes.hide);
      var video = trigger.parentElement.nextElementSibling;
      video.classList.remove(classes.hide);
      var player = new _player2.default(video);
      player.play();
    });
  });
}

function info() {
  if ((0, _jquery2.default)(".kpInfo__button")) {
    (0, _jquery2.default)(".kpInfo__button").on("click", function () {
      var $this = (0, _jquery2.default)(this);
      // Collapse if expanded
      if ($this.hasClass("expanded")) {
        $this.removeClass("expanded").addClass("collapsed");
        $this.attr("aria-expanded", "false");
        $this.parent().siblings().hide();
        $this.parent().siblings().attr("aria-hidden", "true");
      } else if ($this.hasClass("collapsed")) {
        $this.removeClass("collapsed").addClass("expanded");
        $this.attr("aria-expanded", "true");
        $this.parent().siblings().show();
        $this.parent().siblings().attr("aria-hidden", "false");
      }
    });
  }

  if ((0, _jquery2.default)(".kpHero__reviews")) {
    (0, _jquery2.default)('.kpHero__reviews').click(function () {
      var button = (0, _jquery2.default)('.kpInfo__reviews .kpInfo__button');
      (0, _jquery2.default)('html, body').animate({
        scrollTop: button.offset().top
      }, 500);
      if (!button.hasClass('expanded')) {
        button.click();
      }
      return false;
    });
  }
}

function testimonials() {
  (0, _jquery2.default)(selectors.testimonials).slick({
    dots: true,
    arrows: false,
    swipe: true,
    cssEase: 'linear',
    draggable: false,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    fade: false
  });
}

function apps() {
  (0, _jquery2.default)(window).on('load resize orientationchange', function () {
    (0, _jquery2.default)(selectors.appsSlider).each(function () {
      var slider = (0, _jquery2.default)(this);
      if ((0, _jquery2.default)(window).width() > 768) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
      } else {
        if (!slider.hasClass('slick-initialized')) {
          slider.slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            slidesToScroll: 1,
            mobileFirst: true
          });
        }
      }
    });
  });
}

function upgradeData() {
  (0, _jquery2.default)(".kpData__radio").change(function () {
    (0, _jquery2.default)(".kpData__addToCart").attr("disabled", false);
    (0, _jquery2.default)(".kpData__addToCart").css("border", "1px solid #fff");
  });
}